// import { Row } from 'antd';
import React from 'react';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { AppContainer } from 'react-hot-loader';
import ROUTES from 'routes/routeConstants';

import NextApp from './NextApp';
import { unregister } from './registerServiceWorker';
// Add this import:

// Wrap the rendering in a function:

const ErrorFallback = ({ _, resetErrorBoundary }) => (
  <div className='error-fallback' role='alert'>
    <div>
      <p className='main-text'>Something went wrong!</p>
      <button className='reset-button' type='button' onClick={resetErrorBoundary}>
        Reload
      </button>
      <button
        className='gx-ml-2'
        type='button'
        onClick={() => {
          window.location = ROUTES.DASHBOARD;
        }}>
        To Homepage
      </button>
    </div>
  </div>
);

const render = (Component) => {
  ReactDOM.render(
    // Wrap App inside AppContainer
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        window.location.reload();
      }}>
      <AppContainer>
        <Component />
      </AppContainer>
    </ErrorBoundary>,
    document.getElementById('root'),
  );
};

// Do this once
// registerServiceWorker();
unregister();

// Render once
render(NextApp);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./NextApp', () => {
    render(NextApp);
  });
}
